import { Box, keyframes } from '@mui/material'
import { type PropsWithChildren } from 'react'

interface PulseProps extends PropsWithChildren {
  active: boolean
  durationMs?: number
  scaleFactor?: number
}

export default function Pulse({ active, durationMs = 1000, scaleFactor, children }: PulseProps) {
  if (!active) {
    return children
  }

  const pulse = keyframes`
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(${scaleFactor});
    }
    100% {
      transform: scale(1);
    }
  `

  return (
    <Box
      component="div"
      sx={{
        animation: `${pulse} ${durationMs}ms ease infinite`,
      }}
    >
      {children}
    </Box>
  )
}
